import React from 'react';
import * as R from 'ramda';
import { Labeled } from 'react-admin';
import { Box, Typography } from '@material-ui/core';

/**
 * Displays openedx_display when backend provides it; otherwise openedx.
 */
const CourseOpenEdxIdField = ({ record, source }) => {
  const openedx = R.pathOr('', [source, 'openedx'], record);
  const display = R.path([source, 'openedx_display'], record);
  const value =
    display == null || display === '' ? openedx : display;

  return (
    <Box>
      <Labeled label="Github Course ID">
        <Typography component="span" variant="body2">
          {value}
        </Typography>
      </Labeled>
    </Box>
  );
};

export default CourseOpenEdxIdField;
